var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('iframe',{attrs:{"src":_vm.$t('ContactUrl'),"title":_vm.$t('ContactTitle'),"height":"3500","width":"800"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }